import { AccountPlatformType } from "@/shared/types/accounts";

export const VIDEO_REEL_CONSTANTS = {
  ASPECT_RATIO: {
    MIN_NINE_TO_SIXTEEN: 0.55,
    MAX_NINE_TO_SIXTEEN: 0.57,
  },
  DURATION: {
    MAX_REEL_SECONDS: 90,
  },
  SUPPORTED_PLATFORMS: ["FB"] as const satisfies readonly AccountPlatformType[],
  POST_TYPES: {
    VIDEO: "video",
    REEL: "reel",
  },
} as const;

export type VideoPostType =
  (typeof VIDEO_REEL_CONSTANTS.POST_TYPES)[keyof typeof VIDEO_REEL_CONSTANTS.POST_TYPES];
